import React from 'react';
import PropTypes from 'prop-types';
import { pluginFactoryShape } from './helpers/propTypes';
import useLinkedEntities from './helpers/hooks/useLinkedEntities';
import LinkedEntitiesCellView from './LinkedEntitiesCellView';
import objectValues from '@adsk/bim360-matrix-react-helpers/es/objectValues';
import { ENTITY_TYPES } from './helpers/consts';

const LinkedEntitiesCell = ({ container, plugins, sourceEntityType, sourceEntityId }) => {
  const { entities, isLoading, error } = useLinkedEntities(
    sourceEntityType,
    sourceEntityId,
    plugins,
    100
  );

  return (
    <LinkedEntitiesCellView
      plugins={plugins}
      container={container}
      isLoading={isLoading}
      error={error}
      entities={entities.map(({ entity }) => entity)}
    />
  );
};

LinkedEntitiesCell.propTypes = {
  /**
   * The target entity type plugins we want to allow linking to.
   */
  plugins: PropTypes.arrayOf(pluginFactoryShape).isRequired,
  /**
   * A container to attach the tooltip to
   */
  container: PropTypes.object,
  /**
   * The entity ID we want to link to.
   */
  sourceEntityId: PropTypes.string.isRequired,
  /**
   * The source entity type.
   */
  sourceEntityType: PropTypes.oneOf(objectValues(ENTITY_TYPES)).isRequired
};

export default LinkedEntitiesCell;
